import { render, staticRenderFns } from "./ProblemOne.vue?vue&type=template&id=52ec7336&scoped=true&"
import script from "./ProblemOne.vue?vue&type=script&lang=ts&"
export * from "./ProblemOne.vue?vue&type=script&lang=ts&"
import style0 from "./ProblemOne.vue?vue&type=style&index=0&id=52ec7336&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ec7336",
  null
  
)

export default component.exports